import { surveyResultApi } from "api/projectlearning.api";
import { ReasonActionSaveAsDraftOrCompletedRequestDto } from "model/pl-api";
import { appInsights } from "utils/logging/appInsights";

export const saveReasonActionAsDraft = async (
  requestDto: ReasonActionSaveAsDraftOrCompletedRequestDto) => {
  try {
    let x = await surveyResultApi.saveReasonActionAsDraft(requestDto);
  } catch (error: any) {
    console.log(error);
      const additionalProperties = {
      "ApplicationName": "Client App",
      "Request": "saveReasonActionAsDraft",
      "Error": error
    };
    appInsights.trackException({exception: new Error(error)}, additionalProperties);
  }
};
